export default __webpack_public_path__ + "static/media/victoria_nails_010.5fa4b31b.jpg";